import { ItemCompanyResource as Res } from '@shared/resources/item-company';
import { ItemCompanyCreateUpdateDto as DTO } from '@shared/dto/item_company';
import { defineCrudStore } from '@/stores/crud-store';
import { ItemCompanyService } from '@/services/item-company.service';

export const useItemCompaniesStore = defineCrudStore<DTO, DTO, Res>({
  storeId: 'itemCompanies',
  service: new ItemCompanyService(),
});
